import { useRouter } from 'next/router'
import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import type { Dispatch, ReactNode, SetStateAction } from 'react'

type EmbedContextValues = {
  embed: boolean
  setEmbed: Dispatch<SetStateAction<boolean>>
}

const DEFAULT_VALUES: EmbedContextValues = {
  embed: false,
  setEmbed: () => {},
}

const Context = createContext<EmbedContextValues>(DEFAULT_VALUES)

export function EmbedProvider({ children }: { children: ReactNode }) {
  const [embed, setEmbed] = useState<boolean>(false)
  const router = useRouter()
  useEffect(() => {
    setEmbed(router.query.embed === 'true')
  }, [router])

  const values: EmbedContextValues = useMemo(
    () => ({ embed, setEmbed }),
    [embed],
  )

  return <Context.Provider value={values}>{children}</Context.Provider>
}

export function useEmbed() {
  return useContext(Context)
}
